import { useTheSiwe, useThePoolz } from "@poolzfinance/reacthelper"
import { API4Provider } from "@poolzfinance/api4"

const API4Wrapper = ({ children }: { children: React.ReactNode }) => {
  const { account } = useThePoolz()

  const callBack = async () => {
    const fetchGraphQL = async (): Promise<{ data: { time: number } } | undefined> => {
      const headers = {
        "Content-Type": "application/json",
        Authorization: "0x0000000000000000000000000000000000000000"
      }

      const body = {
        operationName: "Time",
        query: `
            query Time {
              time
            }
          `,
        variables: {}
      }

      try {
        const response = await fetch(import.meta.env.VITE_APP_API4_GRAPHQL_URL, {
          method: "POST",
          headers,
          body: JSON.stringify(body)
        })

        if (!response.ok) throw new Error(`HTTP error: ${response.status}`)

        return response.json()
      } catch (error) {
        console.error(error)
      }
    }

    const result = await fetchGraphQL()
    const now = result ? new Date(result.data.time * 1000) : new Date()
    return {
      Domain: import.meta.env.VITE_APP_SIWE_DOMAIN as string,
      URI: import.meta.env.VITE_APP_SIWE_URI as string,
      IssuedAt: now.toISOString(),
      Nonce: now.getTime(),
      ExpirationAt: new Date(
        now.getTime() + 1000 * 60 * 60 * Number(import.meta.env.VITE_APP_SIWE_EXPIRATION_HOURS as string)
      ).toISOString()
    }
  }

  const { signInWithEthereum } = useTheSiwe(callBack)

  return (
    <API4Provider
      account={account}
      options={{ siweCallBack: signInWithEthereum, uri: import.meta.env.VITE_APP_API4_GRAPHQL_URL }}>
      {children}
    </API4Provider>
  )
}

export default API4Wrapper
